import Head from 'next/head';

import { BlackPackages, Hero, Offer, Timer } from '../../components/offers/sections';

// const Balloons = dynamic(() => import('./_sections/Balloons'), { ssr: false });

const SpecialOffers = props => {
  return (
    <div className="black-offer relative">
      <Head>
        <title>Gift Season | Prodigi</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      {/* <Balloons /> */}
      <Hero />
      <Timer />
      <BlackPackages />
      <Offer country={props.country} />
    </div>
  );
};

export default SpecialOffers;
